import client from "services/ngage/api-client";
import {NewNoteData, Note, UpdateNoteData} from "types/Note";
import deserializeNote from "services/ngage/deserializers/note";
import DataResource from "types/DataResource";
import {parameters} from "../string";

type NoteFilters = {
    notableType?: 'exhibit',
    notableId?: number
    search?: string | null
    important?: boolean
    page?: number
    perPage?: number
}

/**
 * Get all notes that match the given filters (paginated)
 */
const all = async (filters: NoteFilters = {}) => {
    try {
        const params = parameters(filters, {page: 1, per_page: 100});
        const response = (await client.get<DataResource<Note> | null>('/notes', {params}))

        if (response?.data) {
            response.data.data = response.data.data.map(deserializeNote)
        }

        return response.data
    } catch (error) {
        console.error("Unable to fetch notes", error)
        return null
    }
}

/**
 * Get a single note
 *
 * @param {number} id
 */
const get = async (id: number) => {
    try{
        const note = (await client.get<Note>(`/notes/${id}`)).data || null
        return note ? deserializeNote(note) : null
    } catch (error) {
        console.error(`Unable to retrieve note ${id}`, error)
        return null
    }
}

/**
 * Store a new note
 *
 * @param data
 */
const store = async (data: NewNoteData) => {
    try{
        const note = (await client.post<Note>('/notes', data)).data || null
        return note ? deserializeNote(note) : null
    } catch (error) {
        console.error("Unable to store note", error)
        throw error;
    }
}

/**
 * Update an existing note
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: UpdateNoteData) => {
    try{
        const note = (await client.put<Note>(`/notes/${id}`, data)).data || null
        return note ? deserializeNote(note) : null
    } catch (error) {
        console.error(`Unable to update note ${id}`, error)
        throw error;
    }
}

/**
 * Permanently delete a note
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    try{
        return (await client.delete<null>(`/notes/${id}`)).status === 204
    } catch (error) {
        console.error(`Unable to destroy note ${id}`, error)
        return null
    }
}

const notes = {
    all,
    get,
    store,
    update,
    destroy
}

export default notes;